import * as React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, PaperProps } from '@mui/material';
import SpinnerButton from '../SpinnerButton';


export interface DialogButton {
    text?:string;
    color?:"inherit" | "error" | "primary" | "secondary" | "info" | "success" | "warning"|undefined
    type?:"button" | "submit" | "reset" | "spinner" | undefined;
    variant?:"text" | "outlined" | "contained"|undefined;
    disabled?:boolean;
    busy?:boolean;
    onClick?: () => void | Promise<void>;
}
interface Props {
    open: boolean;
    title?:string|JSX.Element|JSX.Element[];
    body?:string|JSX.Element|JSX.Element[];
    buttons?:DialogButton[];
    backdropClose?:boolean;
    paperProps?:PaperProps|undefined;
    onClose?:()=>void | Promise<void>;
}

const SimpleDialog = ({ open, title, body, buttons, backdropClose, paperProps, onClose }: Props): JSX.Element => {
    const handleDialogClose = React.useCallback(async (event:object, reason: "backdropClick" | "escapeKeyDown") => {
        if (!backdropClose && (reason && reason === "backdropClick"))
            return;
        onClose && await onClose();
    },[onClose, backdropClose]);

    const buttonElements = React.useMemo(() => {
        return buttons?.map((bt, i) => {
            const handleClick = async () => {
                if (bt.onClick) {
                    await bt.onClick();
                }
            };

            const isSpinner = bt.type == 'spinner';
            return (
                isSpinner ?
                <SpinnerButton key={i}
                    showSpinner={bt.busy||false}
                    onClick={handleClick}
                    color={bt.color}
                    variant={bt.variant}
                    disabled={bt.disabled}
                >
                    {bt.text}
                </SpinnerButton>
                : <Button
                    key={i}
                    type={bt.type != 'spinner' ? bt.type : undefined}
                    onClick={handleClick}
                    color={bt.color}
                    variant={bt.variant}
                    disabled={bt.disabled}
                >
                    {bt.text}
                </Button>
            );
        });
    }, [buttons]);

    return <Dialog open={open} onClose={handleDialogClose} PaperProps={paperProps}>
        <DialogTitle align="center">{title}</DialogTitle>
        <DialogContent>
            {body}
        </DialogContent>
        <DialogActions>
            <Box display="flex" justifyContent="space-between" width="98%">
                { buttonElements }
            </Box>
        </DialogActions>
    </Dialog>
}

export default SimpleDialog;
